export default {
  order_methods: {
    delivery: 'Entrega a domicilio',
    pickup: 'Recogida',
    room_service: 'En el local',
    table_service: 'En el local',
  },
  time: '{{time}} min',
  asap: 'Lo antes posible',
  unavailable: 'No disponible',
  ready_in: 'Listo en ',
  buttons: {
    change: 'Cambiar',
    see_hours: 'Ver horario',
    change_location: 'Cambiar ubicación',
    change_time: 'Cambiar hora',
  },
};
